import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

const DSN =
  'https://d89ce9dcf4954129927929ca326959c2@o212294.ingest.sentry.io/6619336';

Sentry.init({
  ignoreErrors: ['CSRF cookie is not set. Please refresh the page.'],
  dsn: environment.production ? DSN : null,
  integrations: [Sentry.browserTracingIntegration()],
  tracePropagationTargets: ['app.zint.technology', 'app.zint.io'],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0,
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch(err => console.log(err));
